import { Collapsible, LayerCard, Text } from '@cloudflare/kumo'
import { Link } from 'react-router-dom'
import { useTranslation } from '../../i18n'

const QUESTIONS = ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'] as const
const TRIGGER = 'w-full h-12'
const ROW = 'border-b border-kumo-line last:border-b-0'

/** FAQ as Collapsible rows (>=48px, divided). */
export function PrintHelp() {
  const { t } = useTranslation()
  return (
    <LayerCard>
      <LayerCard.Primary>
        <Text as="h2" variant="heading3" DANGEROUS_className="mb-1">
          {t('print.faq.title')}
        </Text>
        <div>
          {QUESTIONS.map((qk) => (
            <Collapsible.Root key={qk} className={ROW}>
              <Collapsible.DefaultTrigger className={TRIGGER}>
                {t(`print.faq.${qk}.q`)}
              </Collapsible.DefaultTrigger>
              <Collapsible.DefaultPanel>
                <div className="pb-3 text-sm">{t(`print.faq.${qk}.a`)}</div>
              </Collapsible.DefaultPanel>
            </Collapsible.Root>
          ))}
          <Collapsible.Root className={ROW}>
            <Collapsible.DefaultTrigger className={TRIGGER}>
              {t('print.faq.q7.q')}
            </Collapsible.DefaultTrigger>
            <Collapsible.DefaultPanel>
              <div className="pb-3 text-sm">
                <Link to="/" className="text-kumo-link underline">
                  {t('print.faq.q7.aLink')}
                </Link>
              </div>
            </Collapsible.DefaultPanel>
          </Collapsible.Root>
        </div>
      </LayerCard.Primary>
    </LayerCard>
  )
}
